<template>
  <!-- eslint-disable vue/no-v-html -->
  <v-img
    src="~@/assets/coach-profile/coach-profile-banner-2.jpg"
    :aspect-ratio="100"
  >
    <v-container
      class="align-stretch top pa-10"
      fluid
    >
      <v-row
        v-if="loading || (coach.profile.testimonials && coach.profile.testimonials.length)"
        class="ma-0"
      >
        <span class="title mb-6">
          <span class="brandFont font-weight-bold">Testimonials</span>
        </span>
        <v-skeleton-loader
          v-if="loading"
          width="700"
          type="paragraph@2"
        />
        <div
          v-else
          style="width: 100%"
        >
          <div
            v-for="(testimonial, key) in coach.profile.testimonials"
            :key="key"
            class="body-2 py-6"
            :class="{'pb-5': key !== coach.profile.testimonials.length -1 }"
          >
            <div class="content mb-0">
              <div
                id="testimonialRender"
                class="brandFont fiveHundred ql-editor"
                v-html="testimonial.content"
              ></div>
            </div>

            <div class="author font-italic font-weight-bold">
              <span class="brandFont">{{ testimonial.author }}</span>
              <span
                v-if="testimonial.position"
                class="brandFont"
              >
                , {{ testimonial.position }}
              </span>
              <span
                v-if="testimonial.company"
                class="brandFont"
              >
                , {{ testimonial.company }}
              </span>
            </div>
          </div>
        </div>
      </v-row>
    </v-container>
  </v-img>
</template>

<script>
export default {
  name: 'Section6',

  props: {
    coach: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
  #testimonialRender {
    &.ql-editor {
      padding: 0 !important;

      * {
        word-break: break-word !important;
        white-space: normal !important;
        color: black !important;
      }
    }
  }
</style>
